<template>
  <div class="animated fadeIn">

    <App-SideMenu></App-SideMenu>

    <main class="cd-main-content landing-color" >
        <ul class="grid">
            
        <h1>HERE ALL BOOKS LIST</h1>
          <li :key="index" v-for="(m ,index) in books">
                <img @click="handleBookM" :kappa="m.bookName" :id="m.bookId" :src="$store.state.urlLink+m.bookId+'.png'" class="swiper-lazy pointer" />
            <!--<br>
            <p style="font-size:9.3px" maxlength="10">
                {{m.bookName}}
            </p>-->
          </li>

        
        <!--<h1>ALL {{type}}</h1>
          <li :key="index" v-for="(m ,index) in books">
              <div v-if="index < MAXVALUE && index <books.length">
                <img @click="handleBookM" :kappa="books[index + Limit].bookName" :id="books[index + Limit].bookId" :src="$store.state.urlLink + books[index + Limit].bookId +'.png'" class="swiper-lazy pointer" />
                {{index + Limit + "->" + books.length}}
              </div>
          </li>
            <div >

                <button @click="BackPage" v-if="Limit > 0">P</button>
                <button @click="NextPage" v-if="Limit + MAXVALUE < books.length">N</button>

            </div>-->
        </ul>


    </main>

    
  </div>
</template>

<script>

import db from '../components/firebase/firebaseinit'
export default 
{
    data() 
    {
      return {
        //MAXVALUE : 50,
        //Limit : 0,
        // The layout mode, possible values are "grid" or "list".
        layout: 'grid',
        books : [],
        type : localStorage.getItem('viewAll')

      };
    },

    methods: 
    {
        handleBookM: function (e)
        {
            //this.$store.state.ChooseContent = this.$store.state.ChooseGridView,
            this.$router.push({
                //name: this.$store.state.ChooseGridView // it depend on category, it will be magazine,newspaper or book
                name: "viewContent"
            })

            if(!e) e = window.event;
                var x = e.currentTarget;
            var book_id = x.id;
            localStorage.setItem('book', book_id);
            
            //this.$store.dispatch('setBookName', book_id);
        },

        /*NextPage()
        {
            this.Limit = this.Limit + this.MAXVALUE
            console.log(this.Limit)
            
        },

        BackPage()
        {
            this.Limit = this.Limit - this.MAXVALUE
            console.log(this.Limit)
        }*/
    },

    created()
    {
        //console.log(localStorage.getItem('viewAll'))

        db.collection('books').orderBy('bookName').get().then(query => 
        { //.where('bookType','==', this.type)
            query.forEach(doc => 
            {
                if(doc.data().bookType == localStorage.getItem('viewAll'))
                {
                    const data = 
                    {
                        id: doc.id,
                        bookId: doc.data().bookId,
                        bookName: doc.data().bookName,
                        bookType: doc.data().bookType,
                        datePublished: doc.data().datePublished,
                        genre: doc.data().genre,
                        language: doc.data().language,
                    }
                    this.books.push(data)
                }
                
            })
            
        })
    }

};
</script>

<style lang="scss" scoped>
/* Hide un-compiled mustache bindings
until the Vue instance is ready */

/*-------------------------
    Grid layout
--------------------------*/
ul
{
    list-style: none;
    width: 80%;
    margin: 0 auto;
    text-align: center;
    color: white;
    float: center;
    margin-left: auto;
    margin-right: auto;
}

@media (max-width: 768px) {
  ul {
    width: 100%;
  }
}

li{
    display: inline-block;
    vertical-align: top;
    padding: 15px;
}

img{
    width:121.5px;
    height:145px;
    object-fit: cover;
    border:none;
    display:block;
    margin-left: auto;
    margin-right: auto;
}

h1
{
    color : white;
    text-align: center;
    text-transform: uppercase;
}



</style>



// WEBPACK FOOTER //
// ViewAll.vue?639a5ba8